import { F360Product } from "@/core/@types/types";
import { EGestaoContratos } from "@/features/financas/views/gestaoContratos/router/types";
import {
  createMemoryHistory,
  createRouter,
  type RouteRecordRaw
} from "vue-router";

const EmptyRouterView = {
  render: () => null
};

export const contratoPendenteRouteName = `${F360Product.Financas}-${EGestaoContratos.Index}`;

const contratoPendenteRoutes: RouteRecordRaw[] = [
  {
    path: "/gestao-de-contratos/",
    name: contratoPendenteRouteName,
    component: EmptyRouterView
  },
  {
    path: "/:pathMatch(.*)*",
    component: EmptyRouterView
  }
];

export function createContratoPendenteRouter() {
  return createRouter({
    history: createMemoryHistory(),
    routes: contratoPendenteRoutes
  });
}
